import { ca } from '@cian/analytics';

import { IOffer } from '../../types/offerData';

export const trackVillagesInView = (offer: IOffer, kpIds: number[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'homes_pro_tariff',
    action: 'offer_card',
    label: 'show_catalog',
    products: [
      {
        id: offer.id,
        offerType: 'offer',
        position: 1,
        extra: {
          kp_PRO_ids: kpIds,
        },
      },
    ],
  });
};

export const trackVillageClick = (id: number, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'homes_pro_tariff',
    action: 'offer_card',
    label: 'click_catalog',
    products: [
      {
        offerType: 'KP',
        id,
        position,
      },
    ],
  });
};

export const trackShowAllVillagesClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'homes_pro_tariff',
    action: 'offer_card',
    label: 'click_full_catalog',
  });
};
